export default {
    name: "sign-up-success",
    props: ["isSuccess"],
    data() {
        return {
            timenow: new Date()
        };
    },
    methods: {
        
    },
    mounted: function () {
        localStorageCacheHelper.removeOtpFormCache("instanceId");
    }
};